<template>
  <div>
    <CommonHead></CommonHead>
    <div class="login">
      <b-jumbotron class="pl-0 pr-0" container-fluid="true" bg-variant="white">
        <b-container fluid>
          <b-row>
            <b-col>
              <div class="login-form">
                <h1>Welcome. Enter New Password.</h1>
                <div class="sign_up">
                  <b-form class="commonform" @submit.prevent="forgotPassword">
                    <b-row>
                      <b-col>
                        <md-field
                          :class="form.errors.get('password')?'haserror':''"
                          :state="!form.errors.has('password')"
                          :invalid-feedback="form.errors.get('password')"
                        >
                          <label>New Password</label>
                          <md-input
                            type="password"
                            v-model="form.password"
                            :state="!form.errors.has('password')"
                            @input="form.errors.clear('password')"
                          ></md-input>
                          <span
                            class="error-msg"
                            v-if="form.errors.get('password')"
                          >{{form.errors.get('password')}}</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <md-field
                          :class="form.errors.get('confirm_password')?'haserror':''"
                          :state="!form.errors.has('confirm_password')"
                          :invalid-feedback="form.errors.get('confirm_password')"
                        >
                          <label>Confirm Password</label>
                          <md-input
                            type="password"
                            v-model="form.confirm_password"
                            :state="!form.errors.has('confirm_password')"
                            @input="form.errors.clear('confirm_password')"
                          ></md-input>
                          <span
                            class="error-msg"
                            v-if="form.errors.get('confirm_password')"
                          >{{form.errors.get('confirm_password')}}</span>
                        </md-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <router-link class="f_pass" to="/shop/login">Login?</router-link>
                      </b-col>
                    </b-row>
                    <b-button type="submit" block variant="dark">Update Password</b-button>
                  </b-form>
                </div>
                <div class="help_signup">
                  <p>Need Help with Sign in?</p>
                  <b-button href="/shop/contact" block variant="outline-primary" squared>Contact Us</b-button>
                </div>
              </div>
            </b-col>
            <b-col class="pr-0 pl-0" cols="5">
              <b-img src="/shop/images/siginimage.jpg" fluid alt="Fluid image"></b-img>
              <div class="signin_div">
                <h1>Request an Account!</h1>
                <p>
                  Please download and complete
                  <br />our application form.
                </p>
                <b-button target="_blank" href="https://rmcoco.com/Resources/Forms/RMCOCO-Account-Application.pdf" block variant="dark">Download Application</b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-jumbotron>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import AuthMixin from "../../mixins/auth";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import { mapGetters } from "vuex";
import ResourceMixin from "../../mixins/resources";

export default {
  components: {
    CommonHead,
    CommonFoot
  },
  mixins: [ResourceMixin],
  data() {
    return {
      form: new Form({
        password: "",
        confirm_password: ""
      }),

      isLoading: false
    };
  },
  methods: {
    forgotPassword() {
      this.isLoading = true;
      this.$store
        .dispatch("newPassword", {
          token: this.$route.params.token,
          form: this.form
        })
        .then(response => {
          if (response.data.success) {
            this.$notify({
              text: response.data.message,
              type: "success"
            });
            this.$router.push("/shop/login");
            this.form = new Form({
              password: null,
              confirm_password: null
            });
          } else {
            this.$notify({
              text: response.data.message,
              type: "error"
            });
          }
        });
      this.isLoading = false;
    }
  }
};
</script>
<style>
.login {
  width: 100%;
  overflow: hidden;
}
.login .bg-white {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
}
.login .img-fluid {
  height: 1045px;
  object-fit: cover;
  width: 100%;
}
.login .login-form {
  max-width: 420px;
  float: right;
  width: 100%;
  margin-right: 280px;
}
.login .login-form h1 {
  margin-top: 110px;
  display: inline-block;
  width: 100%;
  margin-bottom: 30px;
  line-height: 32px;
}
.login .pr-0.col-5.pl-0 {
  max-width: 43.5%;
  flex: 0 0 43.5%;
}
/* .login .md-field.md-has-password .md-toggle-password {
  display: none;
}
.login .md-checkbox .md-checkbox-container {
  border-color: #d2d2d2;
}
.login .md-checkbox {
  margin: 14px 0 0 0;
}
.login .md-checkbox.md-theme-default .md-checkbox-container {
  border-width: 1px;
  border-color: #d2d2d2;
}
.login .md-checkbox .md-checkbox-container:hover {
  border-color: #191919;
}
.login .md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  background-color: #ececec;
}
.login .md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  border-color: #191919;
}
.login .md-checkbox.md-theme-default.md-checked .md-checkbox-container:after {
  border-color: #191919;
}
.login .md-checkbox .md-checkbox-container:after {
  top: 1px;
  left: 6px;
} */
.md-theme-default .login-form .sign_up .forget_pass {
  float: right;
  margin: 15px 0 25px 0;
  color: #303030;
  /* text-decoration: underline; */
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  padding-bottom: 0;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #303030;
  border-radius: 0;
  padding: 0;
}
.md-theme-default .login-form .sign_up .forget_pass:hover {
  text-decoration: none;
}
#app .sign_up .md-checkbox {
  margin: 15px 0 0 0;
}
.login .md-checkbox .md-checkbox-label {
  color: #303030;
  font-weight: 400;
  font-size: 14px;
}
.modal-backdrop {
  background: rgba(0, 0, 0, 0.5);
}
.common_pop .modal-dialog.modal-md {
  max-width: 440px;
  margin-top: 27.5rem;
}
.common_pop .modal-header .close {
  font-size: 24px;
  padding: 0;
  margin: 0;
  font-weight: normal;
  color: #303030;
  opacity: 1;
  position: absolute;
  right: 25px;
  top: 20px;
}
.common_pop .modal-dialog.modal-md .modal-header {
  border-bottom: 0;
}
.common_pop .modal-dialog.modal-md .modal-header h3 {
  font-size: 16px;
  text-align: center;
  display: inline-block;
  width: 100%;
  font-weight: 500;
  color: #303030;
}
.common_pop .modal-dialog.modal-md .modal-content {
  padding: 20px 40px 40px 40px;
  box-sizing: border-box;
}
.common_pop .modal-dialog.modal-md .modal-footer {
  display: none;
}
@media only screen and (max-width: 1440px) and (min-width: 1280px) {
  .login .login-form {
    margin-right: 200px;
  }
}
</style>
